/** True when `rawDate` falls within [fromDate, toDate] inclusive — either bound left empty ('')
 * means unbounded on that side. Dates are compared as calendar days (time-of-day ignored), so a
 * `toDate` of today still includes rows timestamped later that same day. */
export function isWithinDateRange(rawDate: string | null | undefined, fromDate: string, toDate: string): boolean {
  if (!rawDate) return false;
  const day = rawDate.slice(0, 10);
  if (fromDate && day < fromDate) return false;
  if (toDate && day > toDate) return false;
  return true;
}
